import { render, staticRenderFns } from "./queryResultStyle.vue?vue&type=template&id=5718f18d&scoped=true"
import script from "./queryResultStyle.vue?vue&type=script&lang=js"
export * from "./queryResultStyle.vue?vue&type=script&lang=js"
import style0 from "./queryResultStyle.vue?vue&type=style&index=0&id=5718f18d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5718f18d",
  null
  
)

export default component.exports